import api from '../api.js';
import db from '../../versa/db.js';
import crud from '../../versa/crud.js';
import filter, { resolveFilterLabelsToIds, translateForLocations, translate } from '../../versa/filter.js';
import router from '../../versa/router.js';
import formset from '../../versa/formset.js';
import dialog from '../../versa/dialog.js';
import { notify } from '../../versa/msgbox.js';
import { parse, resolvePrinterDeviceId } from '../../versa/misc.js';
import view from '../views/locations.js';
import form from '../forms/locations.js';
import select_printer_form from '../forms/stocks-select-printer.js';
import { formatBiHttpError } from '../views/bi-http-error.js';
import * as types from '../types.js';

function $(sel, root = document) {
	return root.querySelector(sel);
}

function filterExprCompany(companyId) {
	return translate({
		'field-0': 'company_id',
		'operator-0': 'eq',
		'value-0': companyId,
	});
}

async function lcrLoadCompanies(selectEl) {
	const res = await api.list_all_companies();
	if (!res.ok) {
		notify(await res.text(), 'Empresas');
		return;
	}
	let list;
	try {
		list = await res.json();
	} catch (e) {
		notify('Resposta de empresas inválida.', 'Empresas');
		return;
	}
	if (!Array.isArray(list)) return;
	selectEl.innerHTML = '<option value="">— Selecione —</option>';
	for (const c of list) {
		const o = document.createElement('option');
		o.value = c.id;
		o.textContent = c.nick || c.name || c.id;
		selectEl.appendChild(o);
	}
}

async function lcrLoadWarehouses(companyId, sel) {
	sel.innerHTML = '<option value="">Todos</option>';
	if (!companyId) return;
	const fe = encodeURIComponent(filterExprCompany(companyId));
	const res = await api.list_warehouses(`?filter=${fe}&limit=0&sort=2`);
	if (!res.ok) {
		notify(await res.text(), 'Armazéns');
		return;
	}
	const arr = await res.json();
	if (!Array.isArray(arr)) return;
	for (const w of arr) {
		const o = document.createElement('option');
		o.value = String(w.id);
		o.textContent = `${w.name ?? ''} (${w.id})`;
		sel.appendChild(o);
	}
}

async function lcrLoadClasses(companyId, sel) {
	sel.innerHTML = '<option value="">— Todas —</option>';
	if (!companyId) return;
	const fe = encodeURIComponent(filterExprCompany(companyId));
	const res = await api.list_classes(`?filter=${fe}&limit=0&sort=2`);
	if (!res.ok) {
		notify(await res.text(), 'Classes');
		return;
	}
	const arr = await res.json();
	if (!Array.isArray(arr)) return;
	for (const c of arr) {
		const o = document.createElement('option');
		o.value = `${c.company_id}|${c.id}`;
		o.textContent = `${c.name ?? ''} (${c.id})`;
		sel.appendChild(o);
	}
}

function lcrCollectParams(root, format) {
	const companyId = $('#lcr-company', root)?.value?.trim();
	if (!companyId) return null;
	const sp = new URLSearchParams();
	sp.set('format', format);
	sp.set('occupancy', $('#lcr-occupancy', root)?.value || 'all');
	if ($('#lcr-include-disabled', root)?.checked)
		sp.set('include_disabled_locations', '1');
	const wh = $('#lcr-warehouse', root)?.value?.trim();
	if (wh) sp.set('warehouse_id', wh);
	const st = $('#lcr-staging', root)?.value;
	if (st && st !== 'all') sp.set('staging', st);
	const ir = $('#lcr-inreach', root)?.value;
	if (ir && ir !== 'all') sp.set('in_reach', ir);
	const mx = $('#lcr-mix', root)?.value;
	if (mx !== undefined && mx !== null && String(mx).trim() !== '') sp.set('mix', String(mx).trim());
	const cl = $('#lcr-class', root)?.value?.trim();
	if (cl) {
		const parts = cl.split('|');
		if (parts.length >= 2) {
			sp.set('class_company_id', parts[0]);
			sp.set('class_id', parts[1]);
		}
	}
	if (format === 'json') {
		sp.set('limit', $('#lcr-limit', root)?.value || '200');
		sp.set('offset', $('#lcr-offset', root)?.value || '0');
	} else {
		const mxr = $('#lcr-max-rows', root)?.value?.trim();
		if (mxr) sp.set('max_rows', mxr);
	}
	return { companyId, sp };
}

function lcrEsc(s) {
	if (s == null) return '';
	const t = document.createElement('template');
	t.textContent = String(s);
	return t.innerHTML;
}

function lcrRenderPreview(container, rows) {
	if (!rows?.length) {
		container.innerHTML = '<p class="muted mts">Nenhuma linha (ajuste filtros).</p>';
		return;
	}
	const keys = Object.keys(rows[0]);
	let html = '<div class="lcr-scroll mts" style="overflow:auto;max-height:65vh"><table class="view fsx"><thead><tr>';
	for (const k of keys)
		html += `<th>${lcrEsc(k)}</th>`;
	html += '</tr></thead><tbody>';
	for (const r of rows) {
		html += '<tr>';
		for (const k of keys)
			html += `<td>${lcrEsc(r[k])}</td>`;
		html += '</tr>';
	}
	html += '</tbody></table></div>';
	container.innerHTML = html;
}

function lcrDownloadCsv(blob, filename) {
	const a = document.createElement('a');
	a.href = URL.createObjectURL(blob);
	a.download = filename || 'posicoes-catalogo.csv';
	a.click();
	URL.revokeObjectURL(a.href);
}

const locations = function()
{

	let locations_crud = crud.create({
		async loadBaseData()
		{
			const q = this.queryAll();
			api.call(api.list_companies, q).then((data) => db.set('companies', data).catch(error => notify(error)));
			api.call(api.list_warehouses, q).then((data) => db.set('warehouses', data).catch(error => notify(error)));
			api.call(api.list_classes, q).then((data) => db.set('classes', data).catch(error => notify(error)));
			api.call(api.list_devices, q).then((data) => db.set('devices', data).catch(() => {}));
		},
		async queryData(query)
		{
			return await api.call(api.list_locations, query);
		},
		async loadRecord(id)
		{
			let _record = await api.call(api.select_location, ...JSON.parse(id));
			_record.classes = _record.classes.map(entry => [entry.class_company_id, entry.class_id]);
			return _record;
		},
		async editFilter()
		{
			try {
				const data = await api.call(api.list_locations, '?limit=0');
				if (data && Array.isArray(data)) await db.set('locations', data);
			} catch (_) { /* ignore */ }
			filter.edit(this.applyFilter.bind(this), this.filter, {
				reloadLocations: async (formData) =>
				{
					const resolved = await resolveFilterLabelsToIds(formData, this.fieldspecs);
					const parts = [];
					const top = 10;
					for (let i = 0; i < top; i++)
					{
						const f = resolved[`field-${i}`];
						const v = resolved[`value-${i}`];
						if (f === 'company_id' && v) parts.push(`company_id*eq*${v}`);
						else if (f === 'warehouse_id' && v != null && v !== '') parts.push(`warehouse_id*eq*${v}`);
					}
					if (parts.length === 0)
						return;
					const params = new URLSearchParams();
					params.append('filter', parts.join(','));
					params.append('sort', '4');
					params.append('limit', '0');
					const data = await api.call(api.list_locations, '?' + params.toString());
					if (data && Array.isArray(data)) await db.set('locations', data);
				}
			});
		},
		async applyFilter(data)
		{
			this.filter = await resolveFilterLabelsToIds(data, this.fieldspecs);
			this.filterExplicitlyApplied = true;
			api.call(api.list_locations, '?limit=0').then((d) => { if (d && Array.isArray(d)) db.set('locations', d); }).catch(() => {});
			await this.loadPage(1);
		},
		async saveRecord(data, old_data)
		{
			let _record = {
				address: data.address,
				mix: data.mix,
				level: Number(data.level),
				in_reach: data.in_reach == '1',			// Can be: undefined, '0', '1'
				is_staging: data.is_staging == '1',		// Can be: undefined, '0', '1'
				classes: parse(data.classes).map(entry => ({ 
					class_company_id: entry[0],
					class_id: Number(entry[1])
				}))
			};
			// PUT usa company/warehouse/id na URL: o datalist de armazém pode trocar o valor exibido após `company_id` observer
			// sem refletir o armazém real da posição → 404. Sempre atualizar pela chave do registro aberto (old_data).
			if (old_data)
				return await api.call(
					api.update_location,
					old_data.company_id,
					old_data.warehouse_id,
					old_data.id,
					_record
				);
			else
				return await api.call(api.insert_location, data.company_id, data.warehouse_id, _record);
		},
		printLocationLabels()
		{
			const sendRequest = async (data) =>
			{
				const device_id = resolvePrinterDeviceId(data.device_id, '#stocks-select-printer #device_id');
				if (device_id == null)
				{
					notify('Selecione a impressora na lista (clique na opção; só o texto no campo não basta).', 'Atenção');
					return false;
				}
				const sortVal = this.sort_column * (this.sort_order ? -1 : 1);
				const payload = {
					company_id: data.company_id,
					device_id,
					return_zpl: !!data.use_local_agent,
					sort: sortVal,
				};
				const filterExpr = translateForLocations(this.filter, this.fieldspecs);
				if (filterExpr)
					payload.filter = filterExpr;
				else
					payload.ids = await this.getSelectedIds(['company_id', 'warehouse_id', 'id']);
				const result = await api.call(api.print_location_labels, payload);
				if (result?.zpl)
				{
					try
					{
						await api.sendZplToAgent(result.zpl, result.printer, result.printer_key);
						notify('Etiquetas enviadas ao agente local.', 'Impressão');
					}
					catch (e)
					{
						notify(e?.message || String(e), 'Agente local');
						return false;
					}
				}
				return result;
			};
			let fs = formset.create(select_printer_form, sendRequest);
			fs.init = (() =>
			{
				document.querySelector(`${fs.form.selector} #count`).innerHTML = this.record_count;
				Object.getPrototypeOf(fs).init.call(fs);
			})();
		},
		openLocationsCatalogReport()
		{
			const ensureHost = () =>
			{
				let el = document.getElementById('lcr-preview-host');
				if (el) return el;
				const wa = document.getElementById('workarea');
				const title = wa?.querySelector('.title');
				el = document.createElement('div');
				el.id = 'lcr-preview-host';
				el.className = 'mts';
				if (title) title.insertAdjacentElement('afterend', el);
				else wa?.appendChild(el);
				return el;
			};
			const dlgHtml = `
<div class="msgbox" style="min-width: min(36rem, 92vw); max-width: 96vw; text-align: left;">
	<div class="mb-title">Catálogo de posições — filtros</div>
	<div class="mb-text" style="max-height: none;">
		<p class="muted fsxx" style="margin:0 0 0.5rem;">Lista posições com saldo (estoque ativo) por endereço. Use <strong>Ocupação</strong> para restringir a vazias ou com saldo.</p>
		<label>Empresa<sup>*</sup><select id="lcr-company"></select></label>
		<label>Armazém<select id="lcr-warehouse"></select></label>
		<label>Ocupação
			<select id="lcr-occupancy">
				<option value="all">Todas</option>
				<option value="empty">Somente vazias (sem saldo ativo)</option>
				<option value="occupied">Somente com saldo</option>
			</select>
		</label>
		<label><input type="checkbox" id="lcr-include-disabled"> Incluir posições desabilitadas</label>
		<label>Staging
			<select id="lcr-staging">
				<option value="all">Todos</option>
				<option value="yes">Sim</option>
				<option value="no">Não</option>
			</select>
		</label>
		<label>Atuante (ao alcance)
			<select id="lcr-inreach">
				<option value="all">Todos</option>
				<option value="yes">Sim</option>
				<option value="no">Não</option>
			</select>
		</label>
		<label>Mix
			<select id="lcr-mix">
				<option value="">Todos</option>
				<option value="0">Sem restrição de SKUs</option>
				<option value="1">Lotes distintos do SKU</option>
				<option value="2">Apenas mesmo lote</option>
			</select>
		</label>
		<label>Classe (opcional)<select id="lcr-class"></select></label>
		<div style="display:flex;flex-wrap:wrap;gap:0.75rem;margin-top:0.5rem;">
			<label>Prévia: limite<input type="number" id="lcr-limit" value="200" min="1" max="5000" step="1"></label>
			<label>Prévia: offset<input type="number" id="lcr-offset" value="0" min="0" step="1"></label>
			<label>CSV: máx. linhas<input type="number" id="lcr-max-rows" value="50000" min="1" max="200000" step="1"></label>
		</div>
	</div>
	<div class="mts" style="display:flex;flex-wrap:wrap;gap:0.5rem;">
		<button type="button" class="button bn_Preview">Prévia na tela</button>
		<button type="button" class="button bn_ExportCsv">Exportar CSV</button>
		<button type="button" class="button bn_Escape">Fechar</button>
	</div>
</div>`;
			const dlg = dialog.create(dlgHtml, async (key) =>
			{
				const root = dlg.getNode();
				if (key === 'Escape') {
					dlg.destroy();
					return;
				}
				if (key !== 'Preview' && key !== 'ExportCsv') return;
				const pack = lcrCollectParams(root, key === 'Preview' ? 'json' : 'csv');
				if (!pack) {
					notify('Selecione a empresa.');
					return;
				}
				try {
					if (key === 'Preview') {
						const res = await api.locations_catalog_report(pack.companyId, pack.sp.toString());
						const raw = await res.text();
						if (!res.ok) {
							notify(formatBiHttpError(res.status, raw), 'Catálogo de posições');
							return;
						}
						let data;
						try {
							data = JSON.parse(raw);
						} catch (e) {
							notify('Resposta não é JSON.', 'Catálogo de posições');
							return;
						}
						if (!Array.isArray(data)) {
							notify('Formato inesperado da API.', 'Catálogo de posições');
							return;
						}
						dlg.destroy();
						lcrRenderPreview(ensureHost(), data);
						notify(`Prévia: ${data.length} linha(s).`, 'Catálogo de posições');
						return;
					}
					const res = await api.locations_catalog_report(pack.companyId, pack.sp.toString());
					if (!res.ok) {
						const t = await res.text();
						notify(formatBiHttpError(res.status, t), 'Catálogo de posições');
						return;
					}
					const blob = await res.blob();
					const cd = res.headers.get('Content-Disposition');
					let fname = 'posicoes-catalogo.csv';
					if (cd) {
						const m = cd.match(/filename="?([^";]+)"?/i);
						if (m) fname = m[1];
					}
					lcrDownloadCsv(blob, fname);
					dlg.destroy();
					notify('Download do CSV iniciado.', 'Catálogo de posições');
				} catch (e) {
					console.error(e);
					notify(e?.message || String(e), 'Catálogo de posições');
				}
			});
			const root = dlg.getNode();
			const selCo = $('#lcr-company', root);
			const selWh = $('#lcr-warehouse', root);
			const selCl = $('#lcr-class', root);
			lcrLoadCompanies(selCo).then(() => {});
			selCo.addEventListener('change', async () =>
			{
				const id = selCo.value;
				await Promise.all([lcrLoadWarehouses(id, selWh), lcrLoadClasses(id, selCl)]);
			});
		},
	});
	
	// Index = position in the backend's SELECT
	let fieldspecs = [
		{ index: 1, field: 'company_id', label: 'Empresa', types: [types.datalist()], placeholder: '', title: 'Empresa', store: 'companies', labels: ['nick'] },
		{ index: 2, field: 'warehouse_id', label: 'Armazém', types: [types.datalist()], placeholder: '', title: 'Armazém', store: 'warehouses', labels: ['name'] },
		{ index: 3, field: 'location_id', label: 'Posição', types: [types.datalist()], placeholder: '', title: 'Posição (armazém e endereço)', store: 'locations', labels: ['address'], separator: '-' },
		{ index: 4, field: 'address', label: 'Endereço', types: [types.location_address(), types.caps()], placeholder: 'X-Y-Z', title: 'Endereço da posição' },
		{ index: 5, field: 'mix', label: 'Mix', types: [types.opt_location_mix(), types.datalist()], placeholder: '', title: 'Misturas permitidas na posição' },
		{ index: 6, field: 'level', label: 'Nível', types: [types.number(0, 2)], placeholder: '0', title: 'Nível da posição' },
		{ index: 7, field: 'in_reach', label: 'Atuante', types: [types.opt_bool()], placeholder: '', title: 'Posição ao alcance da mão?' },
		{ index: 8, field: 'is_staging', label: 'Staging', types: [types.opt_bool()], placeholder: '', title: 'Posição de descarga de mercadorias?' },
		{ index: 11, field: 'status', label: 'Status', types: [types.opt_location_status(), types.datalist()], placeholder: '', title: 'Status do pedido' },
	];

	const reports = [
		{ hash: '#location-labels', label: 'Etiquetas&nbsp;de&nbsp;posição' },
		{ hash: '#locations-catalog', label: 'Catálogo&nbsp;de&nbsp;posições' },
	];

	router.set('#location-labels', locations_crud.printLocationLabels.bind(locations_crud));
	router.set('#locations-catalog', locations_crud.openLocationsCatalogReport.bind(locations_crud));

	locations_crud.run(
		'locations',
		'Posições',
		document.getElementById('workarea'),
		view,
		form,
		fieldspecs,
		[],
		reports
	);

};

export default locations;

